import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeart = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M22.0702 5.146 C23.7632 5.1461 25.139 5.705 26.2498 6.8159 C27.3607 7.9268 27.9197 9.3025 27.9198 10.9956 C27.9198 11.8295 27.7791 12.6457 27.4969 13.4468 C27.2197 14.2337 26.7193 15.1323 25.9677 16.144 C25.2165 17.1551 24.1934 18.3118 22.8894 19.6157 C21.5821 20.9231 19.9227 22.4831 17.909 24.2974 L16.6697 25.4078 L15.4305 24.2974 C13.4168 22.4831 11.7575 20.9231 10.45 19.6157 C9.1461 18.3118 8.123 17.1551 7.3719 16.1441 C6.6203 15.1322 6.1199 14.2338 5.8426 13.4467 C5.5604 12.6457 5.4198 11.8295 5.4198 10.9956 C5.4199 9.3025 5.9788 7.9268 7.0897 6.8159 C8.2006 5.705 9.5763 5.1461 11.2694 5.146 C12.1996 5.146 13.0816 5.3416 13.9217 5.7349 C14.7632 6.1287 15.4873 6.6828 16.0985 7.4019 C16.241 7.5694 16.4498 7.6655 16.6697 7.6655 C16.8898 7.6655 17.0985 7.5694 17.241 7.4019 C17.8522 6.6828 18.5763 6.1288 19.4178 5.7349 C20.258 5.3416 21.1399 5.146 22.0702 5.146 Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 5.5
		}), /* @__PURE__ */ _jsx("path", {
			d: "M22.0702 5.146 C23.7632 5.1461 25.139 5.705 26.2498 6.8159 C27.3607 7.9268 27.9197 9.3025 27.9198 10.9956 C27.9198 11.8295 27.7791 12.6457 27.4969 13.4468 C27.2197 14.2337 26.7193 15.1323 25.9677 16.144 C25.2165 17.1551 24.1934 18.3118 22.8894 19.6157 C21.5821 20.9231 19.9227 22.4831 17.909 24.2974 L16.6697 25.4078 L15.4305 24.2974 C13.4168 22.4831 11.7575 20.9231 10.45 19.6157 C9.1461 18.3118 8.123 17.1551 7.3719 16.1441 C6.6203 15.1322 6.1199 14.2338 5.8426 13.4467 C5.5604 12.6457 5.4198 11.8295 5.4198 10.9956 C5.4199 9.3025 5.9788 7.9268 7.0897 6.8159 C8.2006 5.705 9.5763 5.1461 11.2694 5.146 C12.1996 5.146 13.0816 5.3416 13.9217 5.7349 C14.7632 6.1287 15.4873 6.6828 16.0985 7.4019 C16.241 7.5694 16.4498 7.6655 16.6697 7.6655 C16.8898 7.6655 17.0985 7.5694 17.241 7.4019 C17.8522 6.6828 18.5763 6.1288 19.4178 5.7349 C20.258 5.3416 21.1399 5.146 22.0702 5.146 Z",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			style: {
				fill: "var(--sticker-bold,#FF687F)",
				stroke: "var(--sticker-dark,#AB2B3E)"
			}
		})]
	});
};
export default SvgHeart;
